import React from 'react'
import { css } from '@emotion/react'
import ListHeader from 'gatsby-theme-marketplace-base/src/components/ProductList/Header/index'
import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

const listHeaderCss = (theme) => css`
  position: sticky;
  top: 48px;
  z-index: 100;
  background-color: ${theme.colors.white};
  padding: 18px 0;
  border-bottom: 1px solid ${theme.colors.gray50};

  .collapse__content {
    > div {
      border-bottom: none;

      > div {
        padding-bottom: 0;
      }
    }
  }

  @media (max-width: ${mediaQueries.BASE_SMALL_SIZE - 1}px) {
    .collapse__label-wrapper > div > div {
      width: 100%;

      span {
        display: none;
      }
    }
  }
`

export default (props) => <ListHeader css={listHeaderCss} {...props} />
